
import { AccountState } from '../enums';

export const AccountStates = [
  { name: 'Active', value: AccountState.Active, undelete: true },
  { name: 'Pending Activation', value: AccountState.PendingActivation, pendingActivation: true, undelete: true },
  { name: 'Deleted', value: AccountState.Deleted, deleted: true },
];

